import React, { useEffect, useState } from "react";
import GlobalHeader from "../../components/header";
import Footer from "../../components/footer";
import { Backdrop, CircularProgress, Stack } from "@mui/material";
import StackedLineChartIcon from "@mui/icons-material/StackedLineChart";
import MapsHomeWorkIcon from "@mui/icons-material/MapsHomeWork";
import SectionHome from "../../components/SectionHome";
import useApi from "../../hooks/useApi";
import useSnack from "../../hooks/useSnack";
import SnackAlert from "../../components/SnackAlert";
import testData from "./demoData.json";

function Home() {
  const [testingData, setTestingData] = useState();
  const { loadApi, loadingApi } = useApi();
  const { msgSB, openSB, showSnack, typeSB } = useSnack();
  const [openBackDrop, setOpenBackDrop] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    const GetPreviewProjects = async () => {
      setOpenBackDrop(true);
      loadApi("home", true, "get")
        .then((response) => {
          setTestingData(response.data);
        })
        .catch((e) => {
          showSnack(e.message);
        })
        .finally(() => setOpenBackDrop(false));
    };

    GetPreviewProjects();
  }, []);

  return (
    <>
      <GlobalHeader />
      <Stack
        component="main"
        sx={{
          pt: 6,
          minHeight: "90vh",
          width: {
            xs: "100vw",
            sm: "95vw",
            md: "95vw",
            lg: "75vw",
          },
          marginInline: "auto",
        }}
      >
        <Stack px={{ xs: 2, md: 2 }}>
          {testingData && (
            <>
                           {/* <SectionHome
                title="Propiedades"
                data={testingData.parsedStates}
                description="Explora nuestra selección de propiedades residenciales y comerciales en las mejores ubicaciones."
                icon={<MapsHomeWorkIcon fontSize="medium" />}
                type="property"
              /> */}

              <SectionHome
                title="Proyectos"
                data={testingData.parsedProjects}
                icon={<StackedLineChartIcon fontSize="medium" />}
                description="Explora nuestros proyectos de inversión con altos rendimientos."
                type="project"
              />
            </>
          )}
        </Stack>
      </Stack>
      <Footer />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openBackDrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <SnackAlert openSB={openSB} typeSB={typeSB} msgSB={msgSB} />
    </>
  );
}

export default Home;
